/**
 * Offer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KreditInsuranceCancellationReminder { 
    offerId?: string;
    applicant?: KreditInsuranceCancellationReminder.ApplicantEnum;
    reminderEnum?: KreditInsuranceCancellationReminder.ReminderEnumEnum;
}
export namespace KreditInsuranceCancellationReminder {
    export type ApplicantEnum = 'ONE' | 'TWO';
    export const ApplicantEnum = {
        One: 'ONE' as ApplicantEnum,
        Two: 'TWO' as ApplicantEnum
    };
    export type ReminderEnumEnum = 'FIRST' | 'SECOND';
    export const ReminderEnumEnum = {
        First: 'FIRST' as ReminderEnumEnum,
        Second: 'SECOND' as ReminderEnumEnum
    };
}


